module.exports = __webpack_public_path__ + "img/somaliland.f6080daa.svg";